import React from 'react';
import styled from 'styled-components';
import { space, layout, typography, color, flexbox } from 'styled-system';

import { getImagePath } from '../../../Util/pathUtils';

const BaseImage = styled.img`
  ${space};
  ${layout};
  ${typography};
  ${color};
  ${flexbox};
`;

const Image = ({ src, srcSet, ...restProps }) => {
  const imagePath = getImagePath(src);
  const imagePathsArr =
    srcSet &&
    srcSet
      .trim()
      .split(',')
      .map((src) => getImagePath(src.trim()));
  const imagePathsString = imagePathsArr && imagePathsArr.toString();
  return <BaseImage src={imagePath} srcSet={imagePathsString} {...restProps} />;
};

export default Image;
